import {Buyer} from '@buncha/driver/types/common';
import {OrderItems} from '@buncha/batchDetails/types';

/* eslint-disable no-shadow */
export interface B2BBarcodeContextState {
  listOfBarcodes: BarcodesOfOrders[];
  barcodesScannedCount: number;
}

export interface BarcodesOfOrders {
  barcodeUrl: string;
  externalId: string;
  buyerInfo: {
    firstName: string;
    lastName: string;
  };
  isBarcodeScanned: boolean;
  totalItemsCount: number;
  legacyOrderId: number;
}

export interface GetBarcodesForExternalCheckoutResponse {
  getBarcodesForExternalCheckout: {
    data: {
      V100: {
        barcodesOfOrders: BarcodesOfOrders[];
        barcodeScannedCount: number;
      };
    };
  };
}

export interface UpdateB2BOrderVerifyStatusResponse {
  updateB2BOrderVerifyStatus: {
    data: {
      V100: {
        status: boolean;
      };
    };
  };
}

export enum OrderVerifyStatus {
  pending = 'pending',
  validationInProgress = 'validationInProgress',
  validationFailed = 'validationFailed',
  validationDone = 'validationDone',
  updationInProgress = 'updationInProgress',
  updationFailed = 'updationFailed',
  updationDone = 'updationDone',
  barcodeScanned = 'barcodeScanned',
  scanSuccessful = 'scanSuccessful',
  scanFailed = 'scanFailed',
}
export interface OrderForOrderInfo {
  buyer: Buyer;
  id: number;
  items: OrderItems[];
}

export interface GetOrderForOrderInfoResponse {
  getOrder: OrderForOrderInfo;
}
